export default "__VITE_ASSET__a9fac13f__"